import {useContext, useState} from 'react';
import {useParams, useHistory} from 'react-router-dom';
import {BasicAddressContent} from 'components/Identity';
import AppContext from 'components/App/AppContext';
import {WidgetLayout} from 'components/App/WidgetLayout';
import {WidgetWrapper} from 'components/App/WidgetWrapper';
import API from 'api';
import {getSavedBasicAddress} from 'api/routes/address';
import {useQuery} from 'react-query';
import {getCountry, getState} from 'utils/helpers';
import {STEPS} from 'components/Identity/BasicAddress/BasicAddressContent';

export const ContinueBasicAddress = () => {
    const {id} = useParams();
    const {push} = useHistory();
    const [errorMsg, setErrorMsg] = useState('');
    const {colors} = useContext(AppContext);
    const [values, setValues] = useState({});
    const [step, setStep] = useState();

    const getAdressQuery = useQuery(
        ['address', id],
        async () => {
            setErrorMsg();
            const response = await API.get(getSavedBasicAddress, {
                params: {
                    reference: id,
                },
            });
            return response.data;
        },
        {
            onSuccess: ({data}) => {
                const country = getCountry(data?.address_country);
                const state = getState(data?.address_state, country?.isoCode);
                const values = {
                    reference: data?.reference,
                    addressLandmark: data?.address_landmark,
                    alias: data?.alias,
                    addressCountry: country,
                    addressState: state,
                    addressCity: data?.address_country,
                    addressLine1: data?.address_line1,
                    addressLine2: data?.address_line2,
                    flatNumber: data?.flat_number,
                    buildingName: data?.building_name,
                    buildingNumber: data?.building_number,
                    postalCode: data?.postal_code,
                };
                setValues(values);
                if (data?.home_image) return push('/');
                if (values?.addressCountry) return setStep(STEPS.BILL);
                return push('/');
            },
            retry: false,
            refetchOnWindowFocus: false,
        }
    );

    return (
        <WidgetWrapper>
            <WidgetLayout currentQuery={getAdressQuery} colors={colors} errorMsg={errorMsg}>
                <BasicAddressContent values={values} step={step} isContinue />
            </WidgetLayout>
        </WidgetWrapper>
    );
};
